export const SEARCH_RESULTS = 'search_results';
export const POST_PAGE = 'post_page';
export const POST_EDIT_PAGE = 'post_edit_page';
export const FEED_PAGE = 'feed_page';
export const CATEGORIES_PAGE = 'categories_page';
export const INVALID_APP_STATE_PAGE = 'invalid_app_state';
